import styled from 'styled-components';
import { Button } from '../../../components/Button';
import { useModal } from '../../../hooks/useModal';

interface StatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'success' | 'error';
  title: string;
  message: string;
}

export const StatusModal = ({ isOpen, onClose, type, title, message }: StatusModalProps) => {
  const { ModalComponent } = useModal({
    isOpen,
    onClose,
    title
  });

  return (
    <ModalComponent>
      <ModalContent>
        <ModalIcon>
          {type === 'success' ? '✅' : '❌'}
        </ModalIcon>
        <ModalMessage>{message}</ModalMessage>
        <Button onClick={onClose}>
          {type === 'success' ? 'Continue' : 'Try Again'}
        </Button>
      </ModalContent>
    </ModalComponent>
  );
};

// Styled Components
const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  text-align: center;
  padding: 1rem;
`;

const ModalIcon = styled.div`
  font-size: 3rem;
`;

const ModalMessage = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.black};
  margin: 0;
  line-height: 1.5;
`;
